const usernameStorageKey = "username";
export function getUsername() {
    const storedUsername = localStorage.getItem(usernameStorageKey);
    if (storedUsername && storedUsername.length > 0) {
        return storedUsername;
    }

    const username = prompt("Please enter your name");
    if (username) {
        localStorage.setItem(usernameStorageKey, username);
        return username;
    }
}

export function copyTextToClipboard(textToCopy) {
	navigator.clipboard.writeText(textToCopy);
}

export const LOG_LEVEL = 0;
export const ERROR_LEVEL = 1;
export const FATAL_LEVEL = 9;


let isWindowFocused = true;
window.addEventListener("focus", () => {
    isWindowFocused = true;
});
window.addEventListener("blur", () => {
    isWindowFocused = false;
});

export function sendDesktopNotification(message, onClick) {
    if (
        Notification.permission === "denied"
        || (isWindowFocused && document.visibilityState === "visible")
    ) {
        return;
    }

    const _onClick = () => {
        window.focus();
        if (onClick) {
            onClick();
        }
    };
    if (Notification.permission === "granted") {
        const notification = new Notification(message);
        notification.onclick = _onClick;
    } else if (Notification.permission === "default") {
        Notification.requestPermission().then(function (permission) {
            if (permission === "granted") {
                const notification = new Notification(message);
                notification.onclick = _onClick;
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/utils.js